// src/plugins/truewatch.js
const TrueWatchRUMPlugin = {
  install(Vue, options) {
    const truewatchAppId = process.env.VUE_APP_TRUEWATCH_APP_ID;
    const truewatchClientToken = process.env.VUE_APP_TRUEWATCH_CLIENT;
    const truewatchEnv = process.env.VUE_APP_TRUEWATCH_ENV;

    if (!truewatchAppId) {
      console.warn('TrueWatch App ID not found');
      return;
    }

    // Load Truewatch script
    const script = document.createElement('script');
    script.src = 'https://static.truewatch.com/browser-sdk/v3/dataflux-rum.js';
    script.async = true;

    script.onload = () => {
      window.DATAFLUX_RUM &&
        window.DATAFLUX_RUM.init({
          applicationId: truewatchAppId,
          site: 'https://id1-rum-openway.truewatch.com',
          clientToken: truewatchClientToken,
          env: truewatchEnv,
          version: '1.0.0',
          service: 'browser',
          sessionSampleRate: 100,
          sessionReplaySampleRate: 70,
          compressIntakeRequests: true,
          trackInteractions: true,
          traceType: 'ddtrace', // Not required, default to ddtrace. Currently, it supports 6 types: ddtrace, zipkin, skywalking_v3, jaeger, zipkin_single_header and w3c_traceparent.
          allowedTracingOrigins: ['https://ugems.id', /https:\/\/.*\.ugems.id/],  // Not required; allow all requests to be injected into the header required by the trace collector. It can be the origin of the request or it can be regular.
        });
      window.DATAFLUX_RUM && window.DATAFLUX_RUM.startSessionReplayRecording()
    };

    document.head.appendChild(script);
  }
};

export default TrueWatchRUMPlugin;